import * as React from 'react';
import { useLocation } from 'react-router-dom';
import { exploreEtherData } from '../../../../Shared/ExploreDataFactory';

export interface INftDescriptionProps {
}

export function NftDescription(props: INftDescriptionProps) {
    const { pathname } = useLocation();
    const nftID = pathname.split("/")[2]

    const singleMatchGigData = exploreEtherData.find(data => data.id === JSON.parse(nftID!))


    return (
        <div className="mt-4 h-48 overflow-auto">
            <p
                className="text-l-LightBlack dark:text-cusBlueWhite text-left break-all text-xs sm:text-base"
            >{singleMatchGigData?.details}</p>
        </div>
    );
}
